// IMPORTS
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import FormHelperText from "@mui/material/FormHelperText";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";

// STYLED COMPONENTS
const StyledBox = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(1),
  marginBottom: theme.spacing(3),
}));

const StyledLabel = styled("label")(({ theme, disabled, error }) => ({
  fontWeight: "bold",
  color: error ? theme.palette.error.main : theme.palette.text.primary,
  ...(disabled && { color: theme.palette.text.disabled }),
}));

// COMPONENT
export default function CustomInput({
  id,
  title,
  error,
  helperText,
  disabled = false,
  required = false,
  size = "small",
  variant = "outlined",
  ...rest
}) {
  return (
    <StyledBox>
      {title && (
        <StyledLabel htmlFor={id} disabled={disabled} error={error}>
          {title}
          {required && <span style={{ color: "red" }}> *</span>}
        </StyledLabel>
      )}
      <TextField
        id={id}
        disabled={disabled}
        error={error}
        size={size}
        variant={variant}
        fullWidth
        {...rest}
      />
      {helperText && (
        <FormHelperText error={error}>{helperText}</FormHelperText>
      )}
    </StyledBox>
  );
}

// PROP TYPES
CustomInput.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  size: PropTypes.oneOf(["small", "medium", "large"]),
  variant: PropTypes.oneOf(["outlined", "filled", "standard"]),
};
